import React from 'react';

import './Tutorial.scss';
import { PostResponse } from '../../../types/models/posts';
import getRandomPostData from './demo-post-data';

import { CreatePost } from './steps/CreatePost/CreatePost';
import { PostExplanation } from './steps/PostExplanation/PostExplanation';
import { ShareLink } from './steps/ShareLink/ShareLink';
import { FriendsReaction } from './steps/FriendsReaction/FriendsReaction';

export function Tutorial() {
  const demoPost: PostResponse = getRandomPostData();
  return (
    <div className='Tutorial'>
    
      <div className='Tutorial__step'>
        <h4 className='Tutorial__step-title'>1. Create Post</h4>
        <div className='Tutorial__step-content'>
          <CreatePost demoPostText={ demoPost.body.text } />
        </div>
      </div>
    
      <div className='Tutorial__step'>
        <h4 className='Tutorial__step-title'>2. The Post</h4>
        <div className='Tutorial__step-content'>
          <PostExplanation demoPost={ demoPost } />
        </div>
      </div>
      
      <div className='Tutorial__step'>
        <h4 className='Tutorial__step-title'>3. Share the post link</h4>
        <div className='Tutorial__step-content'>
          <ShareLink demoPost={ demoPost } />
        </div>
      </div>
      
      <div className='Tutorial__step'>
        <h4 className='Tutorial__step-title'>4. Collect reactions</h4>
        <div className='Tutorial__step-content'>
          <FriendsReaction />
        </div>
      </div>

    </div>
  );
}
